/*
======================================================

Post API Service

Purpose:
Handles all requests related to posts.

Connected Backend Endpoint:
GET /api/posts/

Used In:
Profile page
Feed page
Explore page

======================================================
*/

import axiosInstance from "./axiosInstance";

export const getUserPosts = async (userId) => {
  try {
    const response = await axiosInstance.get(`/posts/?author=${userId}`);
    return response.data?.results || response.data || [];
  } catch (error) {
    console.error("Error fetching user posts:", error);
    throw error;
  }
};

export const createAffiliateLink = async (postId, data) => {
  const response = await axiosInstance.post(`/posts/${postId}/links/`, data);
  return response.data;
};

export const getPostLinks = async (postId) => {
  const response = await axiosInstance.get(`/posts/${postId}/`);
  return response.data?.links || [];
};